export default "__VITE_ASSET__4baa1031__"